// Labels and formats of the Rollo section (design README "Contenido y tono"): Argentine formats, Spanish
// labels for the server codes and words or a dash for missing data, never an empty cell.

import { demoraDays } from "../crmpostventa-shared/crmFormat";

// Generic formats moved to the shared module; re-exported so Rollo keeps importing them from here.
export {
  EMPTY,
  PRIORIDAD_LABELS,
  PRIORIDAD_LEVELS,
  codeOf,
  demoraDays,
  formatCuit,
  formatDate,
  formatDuration,
  formatGestiones,
  formatRelativeDays,
  formatShortDate,
  formatTime,
  labelFor,
  toIsoDate,
  todayIso,
} from "../crmpostventa-shared/crmFormat";

export const ESTADO_LABELS = {
  SOLICITADO: "Solicitado",
  EN_PREPARACION: "En preparación",
  EN_CAMINO: "En camino",
  ENTREGADO: "Entregado",
  CANCELADO: "Cancelado",
};

// Chip tone of each estado (StatusChip tokens status-<tone>-bg / -ink).
export const ESTADO_TONES = {
  SOLICITADO: "requested",
  EN_PREPARACION: "preparing",
  EN_CAMINO: "onway",
  ENTREGADO: "delivered",
  CANCELADO: "cancelled",
};

export const CANAL_LABELS = {
  WHATSAPP: "WhatsApp",
  LLAMADA: "Llamada",
  PRESENCIAL: "Presencial",
  EMAIL: "Email",
};

export const ORIGEN_LABELS = {
  ASESOR: "Asesor",
};

export const MOTIVO_CANCELACION_LABELS = {
  YA_NO_LO_NECESITA: "Ya no lo necesita",
  PEDIDO_DUPLICADO: "Pedido duplicado",
  COMERCIO_DADO_DE_BAJA: "Comercio dado de baja",
  OTRO: "Otro",
};

export const MOTIVO_NO_ENTREGA_LABELS = {
  COMERCIO_CERRADO: "Comercio cerrado",
  DIRECCION_INCORRECTA: "Dirección incorrecta",
  NADIE_PARA_RECIBIR: "Nadie para recibir",
  OTRO: "Otro",
};

export const rollosWord = (cantidad) => (Number(cantidad) === 1 ? "rollo" : "rollos");

export const formatRollos = (cantidad) => {
  const n = Number(cantidad) || 0;
  return `${n} ${rollosWord(n)}`;
};

// Title of the amber demora tag of one gestión.
export const demoraTitle = (dias) => {
  const days = demoraDays(dias);
  return days ? `Más de ${days} días abierta` : "Gestión demorada";
};
